// assets
import { IconDashboard, IconReportMoney } from '@tabler/icons';

// constant
const icons = { IconDashboard, IconReportMoney };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',
    title: 'menu.dashboard.thisTitle',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'menu.dashboard.dashboard',
            type: 'item',
            url: '/dashboard',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'budget-monitor',
            title: 'menu.dashboard.budgetMonitor',
            type: 'item',
            url: '/dashboard/budget-monitor',
            icon: icons.IconReportMoney,
            breadcrumbs: false
        }
    ]
};

export default dashboard;
